// 轮播图初始化函数
function initSwiper(container) {
  const wrapper = container.querySelector('[data-swiper-wrapper]');
  let slides = container.querySelectorAll('[data-swiper-slide]');
  const prevButton = container.querySelector('.mt-swiper-button--prev');
  const nextButton = container.querySelector('.mt-swiper-button--next');
  const pagination = container.querySelector('[data-swiper-pagination]');
  let bullets = container.querySelectorAll('[data-swiper-pagination-bullet]');
 let distance=0

 let currentIndex = 0;
 let totalSlides = slides.length; // may change after loop cloning
 const originalSlidesCount = totalSlides; // keep original count
 let loopPadding = 0; // number of cloned slides on each side when loop enabled
 let isDragging = false;
 let startX = 0;
 let startY = 0;
 let currentX = 0;
 let currentY = 0;
 let translateX = 0;
 
 // 性能优化相关变量
 let rafId = null;
 let isTransitioning = false;
 let lastUpdateTime = 0;
 const UPDATE_THROTTLE = 16; // 约60fps
 
 // 触摸手势方向检测变量
 let isHorizontalSwipe = false;
 let isVerticalSwipe = false;
 let swipeDirection = null;
 let touchStartTime = 0;
 
 
 // 自动轮播相关变量
 let autoPlayInterval = null;
 let isAutoPlaying = false;
 let isPaused = false;
 let progressInterval = null;
 let progressStartTime = 0;
 let isRestartingAutoplay = false; // 防止重复重启自动轮播
 let lastTouchEndTime = 0; // 记录上次触摸结束时间
 let countdownTimer = null; // 倒计时定时器
 
 // 从section设置中获取轮播间隔时间（秒）
 const intervalSetting = parseInt(container.getAttribute('data-interval'));
 const autoPlayDelay = intervalSetting * 1000; // 转换为毫秒
 // PC端最后一屏右侧对齐模式：equal_left_gap 或 edge
 const pcRightGapMode = container.getAttribute('data-pc-right-gap-mode') || 'equal_left_gap';
 // 容器宽度模式：fullscreen 或 max_1200px
 const containerWidthMode = container.getAttribute('data-container-width-mode') || 'fullscreen';
 // 无限轮播设置
 const enableLoop = container.getAttribute('data-enable-loop') === 'true';
 // 轮播项居中显示设置
 const centerSlide = container.getAttribute('data-center-slide') === 'true';

 // 构建克隆项用于无限轮播（参考 test3.liquid 的实现方式）
 function buildClones() {
   if (!enableLoop) return;
   // 清理旧克隆
   Array.from(wrapper.querySelectorAll('[data-swiper-slide][data-loop-cloned]')).forEach((n) => n.remove());
   slides = container.querySelectorAll('[data-swiper-slide]:not([data-loop-cloned])');
   if (slides.length === 0) return;
   
   // 检查第一个 slide 是否有有效宽度，如果没有则等待
   const firstSlide = slides[0];
   if (!firstSlide || firstSlide.offsetWidth === 0) {
     console.log('[mt-swiper] buildClones: slides not ready, retrying...');
     setTimeout(buildClones, 50);
     return;
   }
   
   const visible = Math.max(getVisibleSlidesCount(), 1);
   // 确保 count 不会超过原始 slides 数量，且是有限值
   const count = Math.min(Math.max(visible, 1), slides.length);
   loopPadding = count;
   // 前后各克隆 count 个
   const currentSlides = Array.from(slides);
   for (let i = 0; i < count; i++) {
     // 尾部克隆添加到后面
     const tailClone = currentSlides[i].cloneNode(true);
     tailClone.setAttribute('data-loop-cloned', '1');
     wrapper.appendChild(tailClone);
     // 头部克隆添加到前面
     const headClone = currentSlides[currentSlides.length - 1 - i].cloneNode(true);
     headClone.setAttribute('data-loop-cloned', '1');
     wrapper.insertBefore(headClone, wrapper.firstChild);
   }
   // 重新获取所有 slides（包括克隆）
   slides = container.querySelectorAll('[data-swiper-slide]');
   totalSlides = slides.length;
   console.log('[mt-swiper] buildClones completed', { originalCount: currentSlides.length, totalSlides, loopPadding });
 }

 // 将虚拟索引转换为真实索引
 function indexToReal(i) {
   if (!enableLoop || loopPadding === 0) return i;
   const realCount = originalSlidesCount;
   const x = (i - loopPadding) % realCount;
   return (x + realCount) % realCount;
 }

 // 计算中心偏移量（参考 test3.liquid）
 function centerOffset() {
   if (!centerSlide) return 0;
   const visible = Math.max(getVisibleSlidesCount(), 1);
   return visible === 1 ? 0 : 1; // 如果可见数量为1，中心项是第一个；否则是第二个
 }

 if (totalSlides <= 1) {
   return;
 }

 // 更新变换 - 使用requestAnimationFrame优化
 function updateTransform() {
   if (rafId) {
     cancelAnimationFrame(rafId);
   }
   
   rafId = requestAnimationFrame(() => {
     wrapper.style.transform = `translate3d(${translateX}px, 0, 0)`;
     rafId = null;
   });
 }
 
 // 节流更新函数
 function throttledUpdateTransform() {
   const now = Date.now();
   if (now - lastUpdateTime >= UPDATE_THROTTLE) {
     updateTransform();
     lastUpdateTime = now;
   }
 }

 // 计算容器能显示多少个轮播项目
 function getVisibleSlidesCount() {
   // 使用容器的实际可见宽度，而不是offsetWidth
   const containerRect = container.getBoundingClientRect();
   const containerVisibleWidth = containerRect.width;
   const metrics = getSlideMetrics();
   const slideTotalWidth = metrics.totalWidth;
   // 如果 slideTotalWidth 为 0 或无效，说明 DOM 还没准备好，返回默认值
   if (!slideTotalWidth || slideTotalWidth <= 0) {
     // 返回一个合理的默认值，比如 3（PC端常见可见数量）
     const defaultVisible = window.innerWidth > 768 ? 3 : 1;
     console.log('[mt-swiper] getVisibleSlidesCount: slideTotalWidth is 0, using default', { defaultVisible });
     return defaultVisible;
   }
   // 计算容器能完整显示多少个轮播项目（包括间距）
   const visibleCount = Math.floor(containerVisibleWidth / slideTotalWidth);
   // 确保至少显示1个项目
   const result = Math.max(visibleCount, 1);
   console.log('[mt-swiper] getVisibleSlidesCount', { containerVisibleWidth, slideTotalWidth, visibleCount, result });
   return result;
 }

 // 计算最大可滑动到的索引（基于可见数量的确定性计算）
 function getMaxSlideIndex() {
   // 可见数量至少为1，最多不超过 totalSlides - 1，
   // 这样即使所有项都能放下，也允许至少滑动到 index 1。
   const baseCount = enableLoop ? originalSlidesCount : totalSlides;
   const clampedVisible = Math.min(Math.max(getVisibleSlidesCount(), 1), Math.max(baseCount - 1, 1));
   const computed = baseCount - clampedVisible;
   const maxIdx = computed > 0 ? computed : 1; // 保证可滑动时至少为1
   console.log('[mt-swiper] getMaxSlideIndex', { totalSlides, clampedVisible, computed, maxIdx });
   return maxIdx;
 }

 // 获取轮播项尺寸信息（宽度与外边距）
 function getSlideMetrics() {
   // 优先使用原始 slide（非克隆），如果启用循环的话
   let targetSlide = slides[0];
   if (enableLoop && loopPadding > 0) {
     // 尝试找到第一个原始 slide（非克隆）
     const originalSlide = container.querySelector('[data-swiper-slide]:not([data-loop-cloned])');
     if (originalSlide) {
       targetSlide = originalSlide;
     }
   }
   
   if (!targetSlide) {
     return { width: 0, marginRight: 0, totalWidth: 0 };
   }
   const style = window.getComputedStyle(targetSlide);
   const width = targetSlide.offsetWidth;
   const marginRight = parseFloat(style.marginRight || '0');
   const totalWidth = width + marginRight;
   return { width, marginRight, totalWidth };
 }

 // 计算单个轮播项目的总宽度（包括间距）
 function getSlideTotalWidth() {
   const metrics = getSlideMetrics();
   return metrics.totalWidth;
 }

 // 计算第一个可居中的索引（用于初始化和无限轮播回卷时的起点）
 function getFirstCenterableIndex() {
   if (!centerSlide) return 0;
   const leftGap = parseFloat(getComputedStyle(wrapper).marginLeft) || 0;
   const containerWidth = container.offsetWidth;
   const containerCenterInWrapper = containerWidth / 2 - leftGap;
   for (let i = 0; i < slides.length; i++) {
     const slide = slides[i];
     if (!slide) continue;
     const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
     const computedTranslateX = -(slideCenter - containerCenterInWrapper);
     if (computedTranslateX <= 0) return i;
   }
   return 0;
 }

 // 计算移动端允许的最小 translateX（负值），保证最后一张与右侧保留 15px 间距
 function getMobileMaxNegativeTranslate() {
   const lastSlide = slides[totalSlides - 1];
   if (!lastSlide) return 0;
   const lastRightNoMr = lastSlide.offsetLeft + lastSlide.offsetWidth;
   const containerWidth = container.offsetWidth;
   const maxNegative = -(lastRightNoMr - containerWidth + 15);
   return isFinite(maxNegative) ? maxNegative : 0;
 }

 // 检查最后一个轮播项目是否完整展示在屏幕中
 function isLastSlideFullyVisible() {
   return currentIndex >= getMaxSlideIndex();
 }

 // 更新按钮状态
 function updateButtons() {
   if (prevButton) {
     // 如果开启无限轮播，始终不禁用；否则在第一张时禁用
     if (enableLoop) {
       prevButton.disabled = false;
     } else {
       prevButton.disabled = currentIndex === 0;
     }
   }
   if (nextButton) {
     // 如果开启无限轮播，始终不禁用；否则到达最后一张时禁用
     if (enableLoop) {
       nextButton.disabled = false;
     } else {
       const maxIndex = getMaxSlideIndex();
       // 到达最大索引时禁用（但如果maxIndex为0且currentIndex为0，说明不需要滑动，也禁用）
       nextButton.disabled = currentIndex >= maxIndex;
     }
   }
 }

 // 动态构建分页 dot（根据可见数量计算）
 function buildPaginationDots() {
   if (!pagination) return;
   pagination.innerHTML = '';
   // 设置倒计时动画时长（如果启用自动轮播）
   if (autoPlayDelay > 0) {
     pagination.style.setProperty('--dot-animation-duration', (autoPlayDelay / 1000) + 's');
   }
   
   // 确保DOM已准备好，如果slide宽度为0，延迟计算
   const metrics = getSlideMetrics();
   if (!metrics.totalWidth || metrics.totalWidth <= 0) {
     console.log('[mt-swiper] buildPaginationDots: slide metrics not ready, retrying...');
     setTimeout(buildPaginationDots, 100);
     return;
   }
   
   const visible = Math.max(getVisibleSlidesCount(), 1);
   const baseCount = enableLoop ? originalSlidesCount : totalSlides;
   const totalDots = Math.max(baseCount - visible + 1, 1);
   
   console.log('[mt-swiper] buildPaginationDots', { 
     visible, 
     baseCount, 
     originalSlidesCount, 
     totalSlides, 
     enableLoop, 
     totalDots 
   });
   
   // 获取dot样式类型
   const dotStyle = pagination.getAttribute('data-dot-style') || 'countdown';
   
   for (let i = 0; i < totalDots; i++) {
     const btn = document.createElement('button');
     btn.type = 'button';
     btn.className = 'mt-swiper-pagination-bullet';
     btn.setAttribute('data-swiper-pagination-bullet', String(i));
     btn.setAttribute('aria-label', `跳转到第 ${i + 1} 组`);
     btn.addEventListener('click', () => {
       // Dot i 对应原始左起始索引 i；循环时偏移 loopPadding 到可见区（参考 test3.liquid）
       const targetIndex = enableLoop ? (i + loopPadding) : i;
       goToSlide(targetIndex, true);
     });
     
     
     pagination.appendChild(btn);
   }
   bullets = container.querySelectorAll('[data-swiper-pagination-bullet]');
   updatePagination();
 }

 // 更新分页激活状态
 function updatePagination() {
   if (!pagination) return;
   const visible = Math.max(getVisibleSlidesCount(), 1);
   const baseCount = enableLoop ? originalSlidesCount : totalSlides;
   const totalDots = Math.max(baseCount - visible + 1, 1);
   // 活动 dot 基于真实索引（循环时使用 indexToReal 转换）
   const logicalIndex = enableLoop ? indexToReal(currentIndex) : currentIndex;
   const activeDot = Math.max(0, Math.min(logicalIndex, totalDots - 1));
   
   // 获取dot样式类型
   const dotStyle = pagination.getAttribute('data-dot-style') || 'countdown';
   
   // 清除之前的倒计时定时器
   if (countdownTimer) {
     clearTimeout(countdownTimer);
     countdownTimer = null;
   }
   
   bullets.forEach((bullet, index) => {
     const wasActive = bullet.classList.contains('active');
     const isActive = index === activeDot;
     
     if (isActive && !wasActive && dotStyle === 'countdown') {
       // 对于倒计时样式，需要重置动画才能重新开始
       // 先移除active类，然后重新添加以触发动画
       bullet.classList.remove('active');
       // 强制重排，确保样式更新
       void bullet.offsetWidth;
       // 在下一帧重新添加active类，触发动画
       requestAnimationFrame(() => {
         bullet.classList.add('active');
         
         // 如果是倒计时样式且启用自动轮播，在动画完成后自动切换到下一个item
         if (dotStyle === 'countdown' && autoPlayDelay > 0 && isAutoPlaying && !isPaused) {
           countdownTimer = setTimeout(() => {
             next();
           }, autoPlayDelay);
         }
       });
     } else {
       bullet.classList.toggle('active', isActive);
       
       // 如果当前bullet是active且是倒计时样式，且启用自动轮播，设置定时器
       // 修复：即使wasActive已经是true，也要设置定时器（解决刷新后第一个dot无法自动跳转的问题）
       // 因为函数开始已经清除了countdownTimer，所以这里总是可以安全地设置新定时器
       if (isActive && dotStyle === 'countdown' && autoPlayDelay > 0 && isAutoPlaying && !isPaused) {
         countdownTimer = setTimeout(() => {
           next();
         }, autoPlayDelay);
       }
     }
   });
   
   if (autoPlayDelay <= 0) {
     bullets.forEach((bullet, index) => {
       bullet.style.setProperty('--progress-width', index === activeDot ? '100%' : '0%');
     });
   }
 }

 // 更新PC端进度条（分段）：高亮当前可见数量 + 当前索引
 function updatePcProgress() {
   if (window.innerWidth <= 750) return;
   const chunks = container.querySelectorAll('[data-mt-pc-progress-chunk]');
   if (!chunks || chunks.length === 0) return;
   const total = chunks.length;
   const visible = Math.max(getVisibleSlidesCount(), 1);
   // 使用逻辑索引（循环模式下转换为真实索引）
   const logicalIndex = enableLoop ? indexToReal(currentIndex) : currentIndex;
   const maxIndex = getMaxSlideIndex();
   // 仅当到达最大索引（右侧不能再移动）时，才允许进度条填满
   // 否则在视觉上保留至少一个未激活段，避免"看起来已到终点"
   let activeCount = logicalIndex + visible;
   if (logicalIndex < maxIndex) {
     activeCount = Math.min(activeCount, total - 1);
   } else {
     activeCount = Math.min(activeCount, total);
   }
   chunks.forEach((el, idx) => {
     el.classList.toggle('is-active', idx < activeCount);
   });
   console.log('[mt-swiper] pc progress', { currentIndex, logicalIndex, visible, activeCount, total });
 }

 // 跳转到指定幻灯片
 function goToSlide(index, skipProgressAnimation = false) {
   if (isTransitioning) {
     console.log('[mt-swiper] goToSlide: already transitioning, skipping', { index, currentIndex });
     return; // 防止重复调用
   }
   
   isTransitioning = true;
   const maxIndex = getMaxSlideIndex();
   const oldIndex = currentIndex;
   // 在无限轮播模式下，不限制索引（允许超出 maxIndex，后续会在 transitionend 中处理边界跳转）
   if (enableLoop) {
     currentIndex = Math.max(0, index);
   } else {
     currentIndex = Math.max(0, Math.min(index, maxIndex));
   }
   console.log('[mt-swiper] goToSlide: start', { 
     requestedIndex: index, oldIndex, currentIndex, maxIndex, centerSlide, enableLoop
   });
   
   // 计算单个轮播项目的总宽度（包括间距）
   const slideTotalWidth = getSlideTotalWidth();
   
   // 根据设备类型计算正确的 translateX 值
   if (window.innerWidth <= 768) {
     // 移动端：参考 test3.liquid 的居中计算方式
     if (centerSlide) {
       // 居中模式：以中心项的中心对齐视口中心（参考 test3.liquid）
       const cIdx = currentIndex + centerOffset(); // 中心项的索引
       const containerWidth = container.offsetWidth;
       const viewportCenter = containerWidth / 2;
       
       const centerSlideElement = slides[cIdx];
       if (centerSlideElement) {
         const slideCenter = centerSlideElement.offsetLeft + centerSlideElement.offsetWidth / 2;
         translateX = -(slideCenter - viewportCenter);
         
         // 只做基本边界检查（不能向右移动）
         if (translateX > 0) {
           translateX = 0;
         }
         
         console.log('[mt-swiper] center slide calc (mobile, test3 style)', {
           currentIndex, cIdx, slideCenter, containerWidth, viewportCenter, translateX
         });
       } else {
         translateX = -(currentIndex * slideTotalWidth);
       }
     } else if (currentIndex === maxIndex && maxIndex > 0 && !enableLoop) {
       // 非居中模式：最后一屏的特殊处理
       const lastSlide = slides[totalSlides - 1];
       const lastRightNoMr = lastSlide.offsetLeft + lastSlide.offsetWidth;
       const containerWidth = container.offsetWidth;
       translateX = -(lastRightNoMr - containerWidth + 15);
     } else {
       translateX = -(currentIndex * slideTotalWidth);
     }
   } else {
     // PC端：参考 test3.liquid 的居中计算方式
     if (centerSlide) {
       // 居中模式：以中心项的中心对齐视口中心（参考 test3.liquid）
       const cIdx = currentIndex + centerOffset(); // 中心项的索引
       const leftGap = parseFloat(getComputedStyle(wrapper).marginLeft) || 0;
       const containerWidth = container.offsetWidth;
       const viewportCenter = containerWidth / 2;
       const containerCenterInWrapper = viewportCenter - leftGap;
       
       // 计算中心项的中心位置
       const centerSlideElement = slides[cIdx];
       if (centerSlideElement) {
         const slideCenter = centerSlideElement.offsetLeft + centerSlideElement.offsetWidth / 2;
         translateX = -(slideCenter - containerCenterInWrapper);
         
         // 只做基本边界检查（不能向右移动）
         if (translateX > 0) {
           translateX = 0;
         }
         
         console.log('[mt-swiper] center slide calc (PC, test3 style)', {
           currentIndex, cIdx, leftGap, slideCenter, 
           containerWidth, containerCenterInWrapper, translateX, enableLoop
         });
       } else {
         // 如果中心项不存在，回退到标准计算
         translateX = -(currentIndex * slideTotalWidth);
       }
     } else if (currentIndex === maxIndex && maxIndex > 0 && !enableLoop) {
       // 非居中模式下的最后一张：按 pcRightGapMode 设置对齐
       const leftGap = parseFloat(getComputedStyle(wrapper).marginLeft) || 0;
       const lastSlide = slides[totalSlides - 1];
       if (lastSlide) {
         const lastStyle = getComputedStyle(lastSlide);
         const lastMr = parseFloat(lastStyle.marginRight || '0');
         const lastRightWithMr = lastSlide.offsetLeft + lastSlide.offsetWidth + lastMr;
         const containerWidth = container.offsetWidth;
         
         // 全屏模式下，需要考虑wrapper的margin-left和容器的实际可见宽度
         if (containerWidthMode === 'fullscreen') {
           // 全屏模式：最后一屏对齐计算
           // lastRightWithMr 是最后一屏在wrapper中的右边缘位置（包括margin-right）
           if (pcRightGapMode === 'equal_left_gap') {
             // 右侧留白 = 左侧留白（leftGap）
             // wrapper初始左边缘在容器中的位置 = leftGap
             // 最后一屏右边缘的最终位置 = leftGap + lastRightWithMr + translateX
             // 目标：最后一屏右边缘距离容器右边缘 = leftGap
             // 所以：containerWidth - (leftGap + lastRightWithMr + translateX) = leftGap
             // 因此：translateX = containerWidth - 2 * leftGap - lastRightWithMr
             translateX = containerWidth - 2 * leftGap - lastRightWithMr;
           } else {
             // edge模式：右侧贴边（无留白）
             // 目标：最后一屏右边缘贴容器右边缘
             // 所以：leftGap + lastRightWithMr + translateX = containerWidth
             // 因此：translateX = containerWidth - leftGap - lastRightWithMr
             translateX = containerWidth - leftGap - lastRightWithMr;
           }
         } else {
           // max_1200px模式：使用原有逻辑
           if (pcRightGapMode === 'equal_left_gap') {
             translateX = containerWidth - 2 * leftGap - lastRightWithMr;
           } else {
             const rightGap = 20;
             translateX = containerWidth - rightGap - leftGap - lastRightWithMr;
           }
         }
         
         console.log('[mt-swiper] last screen calc (mode, include mr)', {
           containerWidthMode, pcRightGapMode, leftGap, lastMr, lastOffsetLeft: lastSlide.offsetLeft,
           lastWidth: lastSlide.offsetWidth, lastRightWithMr, containerWidth, translateX
         });
       } else {
         translateX = -(currentIndex * slideTotalWidth);
       }
     } else {
       // 正常情况下的计算（非居中模式，非最后一张）
       translateX = -(currentIndex * slideTotalWidth);
     }
   }
   console.log('[mt-swiper] goToSlide', { oldIndex, requestedIndex: index, currentIndex, maxIndex, slideTotalWidth, translateX });
 
   updateTransform();
   updateButtons();
   updatePagination();
   updatePcProgress();
   
   
   // 设置了轮播间隔时，立即启动进度条动画（移动端）
   if (!skipProgressAnimation && autoPlayDelay > 0 && window.innerWidth <= 768) {
     startProgressAnimation();
   }

   // 解除过渡锁：监听过渡结束并增加兜底超时
   const unlock = () => {
     if (isTransitioning) {
       isTransitioning = false;
       wrapper.removeEventListener('transitionend', onEnd);
       if (unlockTimer) clearTimeout(unlockTimer);
       console.log('[mt-swiper] unlock transition');
     }
   };
   const onEnd = (e) => {
     if (e.propertyName === 'transform') {
       // 无缝循环边界重映射：到达克隆区尽头时瞬时跳回原区（参考 test3.liquid）
       if (enableLoop && loopPadding > 0) {
         const realCount = originalSlidesCount;
         if (currentIndex >= realCount + loopPadding) {
           // 超出右边界，跳回第一个真实位置（参考 test3.liquid，无动画跳转）
           currentIndex = loopPadding;
           wrapper.style.transition = 'none';
           // 使用居中计算（如果开启）
           if (centerSlide) {
             const cIdx = currentIndex + centerOffset();
             if (window.innerWidth > 768) {
               const leftGap = parseFloat(getComputedStyle(wrapper).marginLeft) || 0;
               const containerWidth = container.offsetWidth;
               const viewportCenter = containerWidth / 2;
               const containerCenterInWrapper = viewportCenter - leftGap;
               const centerSlideElement = slides[cIdx];
               if (centerSlideElement) {
                 const slideCenter = centerSlideElement.offsetLeft + centerSlideElement.offsetWidth / 2;
                 translateX = -(slideCenter - containerCenterInWrapper);
                 if (translateX > 0) translateX = 0;
               } else {
                 translateX = -(currentIndex * getSlideTotalWidth());
               }
             } else {
               // 移动端
               const containerWidth = container.offsetWidth;
               const viewportCenter = containerWidth / 2;
               const centerSlideElement = slides[cIdx];
               if (centerSlideElement) {
                 const slideCenter = centerSlideElement.offsetLeft + centerSlideElement.offsetWidth / 2;
                 translateX = -(slideCenter - viewportCenter);
                 if (translateX > 0) translateX = 0;
               } else {
                 translateX = -(currentIndex * getSlideTotalWidth());
               }
             }
           } else {
             translateX = -(currentIndex * getSlideTotalWidth());
           }
           // 立即应用transform，无动画（参考 test3.liquid）
           // 直接同步设置，不使用requestAnimationFrame，确保跳转无感知
           wrapper.style.transform = `translate3d(${translateX}px, 0, 0)`;
           updateButtons();
           updatePagination();
           updatePcProgress();
           // 在下一帧恢复transition，确保跳转完成后才恢复
           requestAnimationFrame(() => {
             requestAnimationFrame(() => {
               wrapper.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
             });
           });
         } else if (currentIndex < loopPadding) {
           // 超出左边界，跳到最后一个真实位置（参考 test3.liquid，无动画跳转）
           currentIndex = realCount + loopPadding - 1;
           wrapper.style.transition = 'none';
           // 使用居中计算（如果开启）
           if (centerSlide) {
             const cIdx = currentIndex + centerOffset();
             if (window.innerWidth > 768) {
               const leftGap = parseFloat(getComputedStyle(wrapper).marginLeft) || 0;
               const containerWidth = container.offsetWidth;
               const viewportCenter = containerWidth / 2;
               const containerCenterInWrapper = viewportCenter - leftGap;
               const centerSlideElement = slides[cIdx];
               if (centerSlideElement) {
                 const slideCenter = centerSlideElement.offsetLeft + centerSlideElement.offsetWidth / 2;
                 translateX = -(slideCenter - containerCenterInWrapper);
                 if (translateX > 0) translateX = 0;
               } else {
                 translateX = -(currentIndex * getSlideTotalWidth());
               }
             } else {
               // 移动端
               const containerWidth = container.offsetWidth;
               const viewportCenter = containerWidth / 2;
               const centerSlideElement = slides[cIdx];
               if (centerSlideElement) {
                 const slideCenter = centerSlideElement.offsetLeft + centerSlideElement.offsetWidth / 2;
                 translateX = -(slideCenter - viewportCenter);
                 if (translateX > 0) translateX = 0;
               } else {
                 translateX = -(currentIndex * getSlideTotalWidth());
               }
             }
           } else {
             translateX = -(currentIndex * getSlideTotalWidth());
           }
           // 立即应用transform，无动画（参考 test3.liquid）
           // 直接同步设置，不使用requestAnimationFrame，确保跳转无感知
           wrapper.style.transform = `translate3d(${translateX}px, 0, 0)`;
           updateButtons();
           updatePagination();
           updatePcProgress();
           // 在下一帧恢复transition，确保跳转完成后才恢复
           requestAnimationFrame(() => {
             requestAnimationFrame(() => {
               wrapper.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
             });
           });
         }
       }
       unlock();
     }
   };
   wrapper.addEventListener('transitionend', onEnd, { once: true });
   const unlockTimer = setTimeout(unlock, 400); // 0.3s 动画的兜底
 }

 // 上一张
 function prev(skipProgressAnimation = false) {
   if (!enableLoop && currentIndex > 0) {
     console.log('[mt-swiper] prev click', { currentIndex });
     goToSlide(currentIndex - 1, skipProgressAnimation);
   } else if (enableLoop) {
     // 无缝循环：正常后退一位
     goToSlide(currentIndex - 1, skipProgressAnimation);
   }
 }

// 下一张
function next(skipProgressAnimation = false) {
  const maxIndex = getMaxSlideIndex();
 
  
  // 检查是否到达最大可滑动索引
  if (!enableLoop && currentIndex < maxIndex) {
    console.log('[mt-swiper] next click -> advance', { currentIndex, maxIndex });
    goToSlide(currentIndex + 1, skipProgressAnimation);
  } else if (enableLoop) {
    // 无缝循环：正常前进一位
    goToSlide(currentIndex + 1, skipProgressAnimation);
  } else {
    // 无限轮播关闭时，如果启用了自动轮播，到达最后一张时跳转到第一张
    if (autoPlayDelay > 0) {
      console.log('[mt-swiper] next at max with autoplay -> jump to first', { currentIndex, maxIndex });
      goToSlide(0, skipProgressAnimation);
    } else {
      // 无限轮播关闭且未启用自动轮播时，到达最大索引位置时不再前进
      console.log('[mt-swiper] next click at max, stay', { currentIndex, maxIndex });
      return;
    }
  }
}

 // 触摸开始
 function handleTouchStart(e) {
   const touch = e.touches[0];
   isDragging = true;
   startX = touch.clientX;
   startY = touch.clientY;
   currentX = startX;
   currentY = startY;
   wrapper.style.transition = 'none';
   // 不在这里暂停自动轮播，等确定是水平滑动后再暂停
   
   // 记录触摸开始时间，用于判断是否为快速滑动
   touchStartTime = Date.now();
   
   // 初始化方向检测
   isHorizontalSwipe = false;
   isVerticalSwipe = false;
   swipeDirection = null;
   
   // 取消之前的动画帧请求
   if (rafId) {
     cancelAnimationFrame(rafId);
     rafId = null;
   }
 }

 // 触摸移动
 function handleTouchMove(e) {
   if (!isDragging) return;
   
   const touch = e.touches[0];
   currentX = touch.clientX;
   currentY = touch.clientY;
   
   const deltaX = currentX - startX;
   const deltaY = currentY - startY;
   const absDeltaX = Math.abs(deltaX);
   const absDeltaY = Math.abs(deltaY);
   
   // 方向检测：只有在移动距离超过阈值时才确定方向
   if (!isHorizontalSwipe && !isVerticalSwipe) {
     const directionThreshold = 10; // 方向检测阈值
     
     if (absDeltaX > directionThreshold || absDeltaY > directionThreshold) {
       if (absDeltaX > absDeltaY) {
         // 水平滑动
         isHorizontalSwipe = true;
         swipeDirection = deltaX > 0 ? 'right' : 'left';
   } else {
         // 垂直滑动
         isVerticalSwipe = true;
         swipeDirection = deltaY > 0 ? 'down' : 'up';
       }
     }
   }
   
   // 如果是垂直滑动，不阻止默认行为，允许页面滚动
   if (isVerticalSwipe) {
     isDragging = false;
     wrapper.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
     return;
   }

   // 如果是水平滑动，阻止默认行为并处理轮播
   if (isHorizontalSwipe) {
     e.preventDefault();
     e.stopPropagation();
     
     // 检测到水平滑动时才暂停自动轮播
     pauseAutoPlay();
     
     const slideTotalWidth = getSlideTotalWidth();
     
     // 根据设备类型计算正确的 translateX 值
     if (window.innerWidth <= 768) {
       // 移动端：有 padding-left: 15px，需要补偿这个偏移
       translateX = -(currentIndex * slideTotalWidth) + deltaX;
       // 约束拖拽范围：不超过 0，且不超过最后贴边位置
       const minTranslate = getMobileMaxNegativeTranslate(); // 负值
       if (translateX < minTranslate) translateX = minTranslate;
       if (translateX > 0) translateX = 0;
     } else {
       // PC端：在初始margin-left基础上，加上拖拽偏移
       translateX = -(currentIndex * slideTotalWidth) + deltaX;
       // 如果无限轮播关闭，限制拖拽范围
       if (!enableLoop) {
         const maxIndex = getMaxSlideIndex();
         const maxTranslate = -(maxIndex * slideTotalWidth); // 最小（最负）的 translateX
         if (translateX < maxTranslate) translateX = maxTranslate;
         if (translateX > 0) translateX = 0;
       }
     }
     
     // 使用节流更新，提高性能
     throttledUpdateTransform();
   }
 }

 // 触摸结束
 function handleTouchEnd(e) {
   if (!isDragging) return;
   
   // 防止重复调用 - 如果距离上次调用时间太短，则忽略
   const currentTime = Date.now();
   const timeDiff = currentTime - lastTouchEndTime;
   
   if (timeDiff < 500) {
     return;
   }
   lastTouchEndTime = currentTime;
   
   isDragging = false;
   wrapper.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

   // 如果是垂直滑动，不处理轮播逻辑，也不干扰定时器
   if (isVerticalSwipe) {
     return;
   }

   // 只有水平滑动才处理轮播逻辑
   if (isHorizontalSwipe) {
     const diff = currentX - startX;
     const touchDuration = Date.now() - touchStartTime;
     const velocity = Math.abs(diff) / touchDuration; // 计算滑动速度
     
     // 动态阈值：根据滑动速度调整
     let threshold = window.innerWidth <= 768 ? 50 : 100;
     
     // 快速滑动时降低阈值
     if (velocity > 0.5) {
       threshold = threshold * 0.6;
     }
     
     // 慢速滑动时提高阈值
     if (velocity < 0.1) {
       threshold = threshold * 1.5;
     }

     if (Math.abs(diff) > threshold) {
       if (diff > 0) {
         // 向左滑动：如果不在第一张，或者开启了无限轮播，允许滑动
         if (currentIndex > 0 || enableLoop) {
           prev(true); // 手动滑动时跳过进度条动画
         } else {
           updateTransform();
           updateButtons();
           updatePagination();
         }
       } else if (diff < 0) {
         // 向右滑动：如果不在最后一张，或者开启了无限轮播，允许滑动
         const maxIndex = getMaxSlideIndex();
         if (currentIndex < maxIndex || enableLoop) {
           next(true); // 手动滑动时跳过进度条动画
         } else {
           updateTransform();
           updateButtons();
           updatePagination();
         }
       } else {
         // 如果没有有效的滑动方向，保持当前位置
         updateTransform();
         updateButtons();
         updatePagination();
       }
     } else {
       // 滑动距离不够，回到当前位置
       updateTransform();
       updateButtons();
       updatePagination();
     }
   } else {
     // 如果没有明确的滑动方向，回到当前位置
     updateTransform();
     updateButtons();
     updatePagination();
   }
   
   // 恢复自动轮播并重新计时
   setTimeout(() => {
     if (autoPlayDelay > 0 && !isRestartingAutoplay) {
       isRestartingAutoplay = true;
       
       // 重新开始自动轮播，这会重新计时
       if (isAutoPlaying) {
         stopAutoPlay();
         startAutoPlay();
       } else {
         startAutoPlay();
       }
       
       // 重置标志
       setTimeout(() => {
         isRestartingAutoplay = false;
       }, 500);
     }
   }, 500); // 增加延迟时间，确保滑动动画完全结束
 }

 // 触摸取消处理
 function handleTouchCancel(e) {
   if (!isDragging) return;
   
   // 触摸取消时直接重置状态，不处理轮播逻辑
   isDragging = false;
   wrapper.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
   
   // 恢复自动轮播
   if (autoPlayDelay > 0) {
     resumeAutoPlay();
   }
 }

 // 鼠标按下
 function handleMouseDown(e) {
       isDragging = true;
   startX = e.clientX;
   currentX = startX;
   wrapper.style.transition = 'none';
   wrapper.style.cursor = 'grabbing';
 }

 // 鼠标移动
 function handleMouseMove(e) {
       if (!isDragging) return;
   e.preventDefault();
   currentX = e.clientX;
   const diff = currentX - startX;
   const slideTotalWidth = getSlideTotalWidth();
   
   // 根据设备类型计算正确的 translateX 值
   if (window.innerWidth <= 768) {
     // 移动端：有 padding-left: 15px，需要补偿这个偏移
     translateX = -(currentIndex * slideTotalWidth) + diff;
     // 约束拖拽范围：不超过 0，且不超过最后贴边位置
     const minTranslate = getMobileMaxNegativeTranslate(); // 负值
     if (translateX < minTranslate) translateX = minTranslate;
     if (translateX > 0) translateX = 0;
   } else {
     // PC端：在初始margin-left基础上，加上拖拽偏移
     translateX = -(currentIndex * slideTotalWidth) + diff;
     // 如果无限轮播关闭，限制拖拽范围
     if (!enableLoop) {
       const maxIndex = getMaxSlideIndex();
       const maxTranslate = -(maxIndex * slideTotalWidth); // 最小（最负）的 translateX
       if (translateX < maxTranslate) translateX = maxTranslate;
       if (translateX > 0) translateX = 0;
     }
   }
   
   // 使用节流更新，提高性能
   throttledUpdateTransform();
 }

 // 鼠标释放
 function handleMouseUp(e) {
     if (!isDragging) return;
     isDragging = false;
   wrapper.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
   wrapper.style.cursor = 'grab';

   const diff = currentX - startX;
   const threshold = 100;

   if (Math.abs(diff) > threshold) {
     if (diff > 0) {
       // 向左拖拽：如果不在第一张，或者开启了无限轮播，允许拖拽
       if (currentIndex > 0 || enableLoop) {
         prev(true); // 手动拖拽时跳过进度条动画
       } else {
         updateTransform();
         updateButtons();
         updatePagination();
       }
     } else if (diff < 0) {
       // 向右拖拽：如果不在最后一张，或者开启了无限轮播，允许拖拽
       const maxIndex = getMaxSlideIndex();
       if (currentIndex < maxIndex || enableLoop) {
         next(true); // 手动拖拽时跳过进度条动画
       } else {
         updateTransform();
         updateButtons();
         updatePagination();
       }
     } else {
       // 如果没有有效的拖拽方向，保持当前位置
       updateTransform();
       updateButtons();
       updatePagination();
     }
   } else {
     // 拖拽距离不够，回到当前位置
     updateTransform();
     updateButtons();
     updatePagination();
   }
   
   // 恢复自动轮播并重新计时
   setTimeout(() => {
     if (autoPlayDelay > 0 && !isRestartingAutoplay) {
       isRestartingAutoplay = true;
       
       // 重新开始自动轮播，这会重新计时
       if (isAutoPlaying) {
         stopAutoPlay();
         startAutoPlay();
       } else {
         startAutoPlay();
       }
       
       // 重置标志
       setTimeout(() => {
         isRestartingAutoplay = false;
       }, 2000);
     }
   }, 1500); // 增加延迟时间，确保滑动动画完全结束
 }

 // 鼠标离开
 function handleMouseLeave(e) {
   if (isDragging) {
     handleMouseUp(e);
   }
 }

 // 开始进度条动画
 function startProgressAnimation() {
   if (autoPlayDelay <= 0) return;
   
   // 使用逻辑索引而非实际索引（处理循环时的克隆偏移）
   const baseCountForDots = enableLoop ? originalSlidesCount : totalSlides;
   const logicalIndexForStart = enableLoop ? indexToReal(currentIndex) : currentIndex;
   const activeBullet = bullets[logicalIndexForStart];
   if (!activeBullet) return;
   
   // 重置暂停状态
   isPaused = false;
   
   // 停止之前的进度条动画
   if (progressInterval) {
     clearInterval(progressInterval);
     progressInterval = null;
   }
   
   // 立即重置所有进度条为 0%
   bullets.forEach(bullet => {
     bullet.style.setProperty('--progress-width', '0%');
   });
   
   progressStartTime = Date.now();
   
   progressInterval = setInterval(() => {
     if (isPaused) return;
     
     const elapsed = Date.now() - progressStartTime;
     const progress = Math.min((elapsed / autoPlayDelay) * 100, 100);
     
     // 确保当前活跃的bullet存在（循环模式下使用逻辑索引）
     const baseCount = enableLoop ? originalSlidesCount : totalSlides;
     const logicalIndex = enableLoop ? indexToReal(currentIndex) : currentIndex;
     const currentActiveBullet = bullets[logicalIndex];
     if (currentActiveBullet) {
       currentActiveBullet.style.setProperty('--progress-width', progress + '%');
     }
     
     if (progress >= 100) {
       clearInterval(progressInterval);
       progressInterval = null;
     }
   }, 16); // 约60fps的更新频率
 }

 // 停止进度条动画
 function stopProgressAnimation() {
   if (progressInterval) {
     clearInterval(progressInterval);
     progressInterval = null;
   }
 }

 // 开始自动轮播
 function startAutoPlay() {
   if (autoPlayDelay <= 0 || isAutoPlaying) return;
   
   isAutoPlaying = true;
   isPaused = false; // 重置暂停状态
   startProgressAnimation();
   
   // 获取dot样式类型
   const dotStyle = pagination ? (pagination.getAttribute('data-dot-style') || 'countdown') : 'countdown';
   
   // 如果是倒计时样式，不使用setInterval，而是通过updatePagination中的countdownTimer控制
   // 如果不是倒计时样式，使用setInterval
   if (dotStyle !== 'countdown') {
     autoPlayInterval = setInterval(() => {
       if (!isPaused) {
         next();
       }
     }, autoPlayDelay);
   } else {
     // 倒计时样式：通过updatePagination中的countdownTimer控制，这里只需要触发一次updatePagination
     updatePagination();
   }
 }

 // 停止自动轮播
 function stopAutoPlay() {
   if (autoPlayInterval) {
     clearInterval(autoPlayInterval);
     autoPlayInterval = null;
   }
   if (countdownTimer) {
     clearTimeout(countdownTimer);
     countdownTimer = null;
   }
   stopProgressAnimation();
   isAutoPlaying = false;
 }

 // 暂停自动轮播
 function pauseAutoPlay() {
   isPaused = true;
   if (countdownTimer) {
     clearTimeout(countdownTimer);
     countdownTimer = null;
   }
   stopProgressAnimation();
 }

 // 恢复自动轮播
 function resumeAutoPlay() {
   isPaused = false;
   startProgressAnimation();
   // 重新设置倒计时定时器
   const dotStyle = pagination ? (pagination.getAttribute('data-dot-style') || 'countdown') : 'countdown';
   if (dotStyle === 'countdown' && autoPlayDelay > 0) {
     updatePagination();
   }
 }

 // 键盘事件
 function handleKeyDown(e) {
   if (e.key === 'ArrowLeft') {
     e.preventDefault();
     prev();
   } else if (e.key === 'ArrowRight') {
     e.preventDefault();
     // 允许右箭头键循环回到第一张
     next();
   }
 }

 // 防抖函数
 function debounce(func, wait) {
   let timeout;
   return function executedFunction(...args) {
     const later = () => {
       clearTimeout(timeout);
       func(...args);
     };
     clearTimeout(timeout);
     timeout = setTimeout(later, wait);
   };
 }

 // 窗口大小改变
 function handleResize() {
   // 如果启用循环，重建克隆（因为可见数量可能改变）
   if (enableLoop) {
     buildClones();
     // 确保索引在合法范围内
     const realCount = originalSlidesCount;
     if (currentIndex < loopPadding) {
       currentIndex = loopPadding;
     } else if (currentIndex >= realCount + loopPadding) {
       currentIndex = realCount + loopPadding - 1;
     }
   }
   if (pagination) buildPaginationDots();
   goToSlide(currentIndex);
   
   // 如果设置了轮播间隔且大于0，启动自动轮播（PC和移动端都支持）
   if (autoPlayDelay > 0 && !isAutoPlaying) {
     setTimeout(() => {
       startAutoPlay();
     }, 500);
   }
 }
 
 // 创建防抖的resize处理函数
 const debouncedHandleResize = debounce(handleResize, 250);

 // 绑定事件
 function bindEvents() {

   if (prevButton) {
     prevButton.addEventListener('click', (e) => {
       e.preventDefault();
       console.log('[mt-swiper] prevButton clicked', { disabled: prevButton.disabled, currentIndex });
       prev();
       updatePcProgress();
       // 点击按钮时重新开始自动轮播计时（PC和移动端都支持）
       if (autoPlayDelay > 0) {
         if (isAutoPlaying) {
           stopAutoPlay();
           setTimeout(() => startAutoPlay(), 1000);
         }
       }
     });
   }
   if (nextButton) {
     nextButton.addEventListener('click', (e) => {
       e.preventDefault();
       console.log('[mt-swiper] nextButton clicked', { disabled: nextButton.disabled, currentIndex });
       next();
       updatePcProgress();
       // 点击按钮时重新开始自动轮播计时（PC和移动端都支持）
       if (autoPlayDelay > 0) {
         if (isAutoPlaying) {
           stopAutoPlay();
           setTimeout(() => startAutoPlay(), 1000);
         }
       }
     });
   }

   // 分页点击事件
   bullets.forEach((bullet, index) => {
     bullet.addEventListener('click', () => {
       goToSlide(index, true); // 跳过进度条动画
       // 点击分页后重新开始自动轮播计时（PC和移动端都支持）
       if (autoPlayDelay > 0) {
         if (isAutoPlaying) {
           stopAutoPlay();
           setTimeout(() => startAutoPlay(), 1000);
         }
       }
     });
   });

   // 触摸事件
   wrapper.addEventListener('touchstart', handleTouchStart, { passive: false });
   wrapper.addEventListener('touchmove', handleTouchMove, { passive: false });
   wrapper.addEventListener('touchend', handleTouchEnd, { passive: true });
   wrapper.addEventListener('touchcancel', handleTouchCancel, { passive: true });

   // 鼠标事件
   wrapper.addEventListener('mousedown', handleMouseDown);
   wrapper.addEventListener('mousemove', handleMouseMove);
   wrapper.addEventListener('mouseup', handleMouseUp);
   wrapper.addEventListener('mouseleave', handleMouseLeave);

   // 窗口大小改变事件 - 使用防抖优化
   window.addEventListener('resize', debouncedHandleResize);
   
   // 页面可见性改变事件
   document.addEventListener('visibilitychange', () => {
     if (document.hidden) {
       pauseAutoPlay();
     } else {
       if (isAutoPlaying) {
         resumeAutoPlay();
       }
     }
   });
 }

 

 
 // 初始化克隆和位置（参考 test3.liquid 的实现方式）
 const initPosition = () => {
   // 确保 slide 位置信息已计算
   if (slides.length > 0 && slides[0].offsetWidth > 0) {
     // 先构建克隆（如果启用循环）
     if (enableLoop) {
       // buildClones 可能会延迟执行，所以需要等待它完成
       const tryInitAfterClones = () => {
         // 如果 buildClones 还在重试（loopPadding 还是 0），继续等待
         if (loopPadding === 0 && enableLoop) {
           setTimeout(tryInitAfterClones, 50);
           return;
         }
         // 克隆完成后，设置初始索引
         setInitialIndex();
       };
       buildClones();
       // 等待克隆完成（给一个短暂的延迟，确保 DOM 更新完成）
       setTimeout(tryInitAfterClones, 100);
     } else {
       // 不启用循环，直接设置初始索引
       setInitialIndex();
     }
   } else {
     // 如果位置信息还未准备好，再等一段时间
     console.log('[mt-swiper] slides not ready yet, retrying...', {
       slidesLength: slides.length,
       firstSlideWidth: slides[0]?.offsetWidth || 0
     });
     setTimeout(initPosition, 100);
   }
 };
 
 // 设置初始索引的辅助函数
 function setInitialIndex() {
   // 设置初始索引：如果启用循环，从第一个真实项开始（即 loopPadding）
   if (enableLoop && loopPadding > 0) {
     currentIndex = loopPadding;
   } else {
     currentIndex = 0;
   }
   
   if (centerSlide && !enableLoop) {
     // 居中模式：找到第一个可以居中的 item（计算出负值）
     const leftGap = parseFloat(getComputedStyle(wrapper).marginLeft) || 0;
     const containerWidth = container.offsetWidth;
     const containerCenterInWrapper = containerWidth / 2 - leftGap;
     let firstCenterableIndex = 0;
     
     // 从第一个 item 开始检查，找到第一个可以居中的 item
     for (let i = 0; i < slides.length; i++) {
       const slide = slides[i];
       if (slide) {
         const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
         const computedTranslateX = -(slideCenter - containerCenterInWrapper);
         if (computedTranslateX <= 0) {
           // 如果计算出负值或0，说明可以居中或已经居中
           firstCenterableIndex = i;
           break;
         }
       }
     }
     
     console.log('[mt-swiper] initializing with centerSlide enabled', { 
       currentIndex, centerSlide, 
       firstSlideOffsetLeft: slides[0].offsetLeft,
       firstSlideWidth: slides[0].offsetWidth,
       containerWidth: container.offsetWidth,
       firstCenterableIndex
     });
     goToSlide(firstCenterableIndex, true); // 跳到第一个可以居中的 item
   } else {
     // 非居中模式：确保初始位置正确
     goToSlide(currentIndex, true);
   }
 }
 
 // 使用 requestAnimationFrame 确保在下一帧执行
 requestAnimationFrame(() => {
   setTimeout(initPosition, 50);
 });
 
 bindEvents();
 if (pagination) buildPaginationDots();
 updateButtons();
 updatePagination();
 updatePcProgress();
 
 // 如果设置了轮播间隔且大于0，则启动自动轮播（PC和移动端都支持）
 if (autoPlayDelay > 0) {
   // 延迟启动自动轮播，确保页面完全加载
   setTimeout(() => {
     startAutoPlay();
   }, 1000);
 }
}

// 页面加载完成后初始化所有轮播图
document.addEventListener('DOMContentLoaded', function () {
 const swiperContainers = document.querySelectorAll('[data-section-type="swiper"]');
 swiperContainers.forEach((container) => {
   initSwiper(container);
 });
});

// 如果页面已经加载完成，立即初始化
if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', function () {
   const swiperContainers = document.querySelectorAll('[data-section-type="swiper"]');
   swiperContainers.forEach((container) => {
     initSwiper(container);
   });
 });
} else {
 const swiperContainers = document.querySelectorAll('[data-section-type="swiper"]');
 swiperContainers.forEach((container) => {
   initSwiper(container);
 });
}